module.exports = __webpack_public_path__ + "static/media/close.97a65921.svg";